import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateDiscountList = {
  discountList: { data: null, loading: false, error: null },
};

export const discountList = createAsyncThunk('user/discountList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/discount/list`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerDiscountList = {
  [discountList.pending]: (state) => {
    state.discountList.loading = true;
  },
  [discountList.fulfilled]: (state, action) => {
    state.discountList.loading = false;
    state.discountList.data = action.payload;
    state.discountList.error = null;
  },
  [discountList.rejected]: (state, action) => {
    state.discountList.data = null;
    state.discountList.loading = false;
    state.discountList.error = action.payload;
  },
};
